import { hasProp } from '@/utils/validate.utils';

/**
 * Convierte una duración en un porcetaje respecto de un día completo
 */
function hourToPercent(hour, minutes) {
  const minutesInDay = 1440;
  const totalMinutes = hour * 60 + minutes;
  return Math.floor((totalMinutes / minutesInDay) * 100);
}

/**
 * Transforma las programaciones en barras para su representación gráfica
 *
 * @param {Object} schedules - Programaciones de un dispositivo agrupadas por días y ordenadas por horas de ejecución
 * @return {Object} - Programaciones en barras agrupadas por días
 */
const getSchedulesBar = schedules => {
  const daysBar = [];
  let lastSchedule = {};

  /**
   * ÚLTIMA PROGRAMACIÓN ACTIVA DE LA SEMANA
   *
   * Si la semana termina con una programación de encendido,
   * debería empezar con esa misma programación.
   */
  for (let i = 6; i >= 0; i -= 1) {
    if (hasProp(schedules, i)) {
      for (let j = schedules[i].length; j >= 0; j -= 1) {
        if (schedules[i][j] && schedules[i][j].enabled) {
          const scheduleItem = schedules[i][j];
          lastSchedule.left = 0;
          lastSchedule.power = scheduleItem.power;
          lastSchedule.mode = scheduleItem.mode || null;
          break;
        }
      }

      if (hasProp(lastSchedule, 'left')) break;
    }
  }

  /**
   * GENERAR BARRAS DE PROGRAMACIÓN POR DÍAS
   */
  for (let i = 0; i < 7; i += 1) {
    const today = [];

    /**
     * Cualquier programación que venga de otro día, empieza en la posición cero
     */
    lastSchedule.left = 0;

    /**
     * Si el día tiene programaciones, recorro todas las que están activas
     */
    if (hasProp(schedules, i)) {
      // eslint-disable-next-line
      schedules[i].forEach(schedule => {
        if (schedule.enabled) {
          const bar = {};
          const scheduleItem = {};
          scheduleItem.left = hourToPercent(schedule.hour, schedule.minutes);
          scheduleItem.power = schedule.power;
          scheduleItem.mode = scheduleItem.power ? schedule.mode : null;

          /**
           * Las barras se generan desde la última programación (lastSchedule)
           * hasta la programación actual (scheduleItem),
           * solo generamos una barra si la última programación es un encendido.
           *
           * En caso contrario mostraremos una línea gris
           * indicando que la última acción es un apagado
           */
          if (lastSchedule.power) {
            bar.left = `${lastSchedule.left}%`;
            bar.width = `${scheduleItem.left - lastSchedule.left}%`;
            bar.color = lastSchedule.mode;
          } else {
            bar.left = `${lastSchedule.left}%`;
            bar.width = '2px';
            bar.color = 'off';
          }

          today.push(bar);
          lastSchedule = scheduleItem;
        }
      });
    }

    /**
     * ÚLTIMA PROGRAMACIÓN DEL DÍA
     *
     * Si la última programación del día es un encendido
     * genero una barra desde esta, hasta el final del día
     */
    if (lastSchedule.power) {
      const bar = {};
      bar.left = `${lastSchedule.left}%`;
      bar.width = `${100 - lastSchedule.left}%`;
      bar.color = lastSchedule.mode;
      today.push(bar);
    }

    daysBar.push(today);
  }

  return daysBar;
};

/**
 * Ordena dos programaciones en base a su hora de inicio
 *
 * @param {Object} schedule1 - Programación 1
 * @param {Object} schedule2 - Programación 2
 */
const sortSchedules = (schedule1, schedule2) => {
  if (
    schedule1.hour < schedule2.hour ||
    (schedule1.hour === schedule2.hour && schedule1.minutes < schedule2.minutes)
  ) {
    return -1;
  }

  return 1;
};

// eslint-disable-next-line
export { getSchedulesBar, sortSchedules };
